import { Phone, MessageSquare } from "lucide-react";
import { BIZ } from "@/content";

export const MobileBar = ({ onQuote }) => (
  <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-2 gap-3 border-t border-slate-200 bg-white/95 p-3 backdrop-blur-xl md:hidden" data-testid="mobile-sticky-bar">
    <a href={BIZ.tel} data-testid="mobile-call-now-button" className="flex h-14 items-center justify-center gap-2 rounded-full bg-[#E05A00] font-bold text-white active:scale-95">
      <Phone className="h-5 w-5" /> Call now
    </a>
    <button onClick={() => onQuote()} data-testid="mobile-get-quote-button" className="flex h-14 items-center justify-center gap-2 rounded-full bg-[#0F2B5B] font-bold text-white active:scale-95">
      <MessageSquare className="h-5 w-5" /> Get a quote
    </button>
  </div>
);
